export const ActionType = {
  GetDetail: Symbol("GetTenantDetail"),
  GetList: Symbol("GetTenantList"),
  Create: Symbol("CreateTenant"),
  Update: Symbol("UpdateTenant"),
  UpdateStatus: Symbol("UpdateStatus"),
  CreateSuperModerator: Symbol("CreateSuperModerator"),
  UpdateSuperModerator: Symbol("UpdateSuperModerator"),
  DeleteLogo: Symbol("DeleteLogo"),
  PatchIntroVideo: Symbol("PatchIntroVideo"),
};
